/**
 * @generated SignedSource<<a6d2fe6c02b95e087dc254cb9bd6c6d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CANT_DELETE_TASK_REASON = "HAS_LOCKED_TIME" | "HAS_INVOICED_TIME" | "HAS_TIME_REGS" | "HAS_OTHER_PEOPLES_TIME_REGS" | "JIRA" | "GITHUB" | "UNIT4" | "NO_USER_TYPE" | "BLOCKED_BY_SUBTASK" | "NO_PERMISSION" | "%future added value";
export type DEPENDENCY_TYPE = "CANNOT_START" | "CANNOT_BE_COMPLETED" | "%future added value";
export type PROGRAM_BUDGET_TYPE = "UNCAPPED" | "CAPPED" | "FIXED_PRICE" | "%future added value";
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
export type STATUS_CATEGORY = "TODO" | "INPROGRESS" | "DONE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type taskModalV3_task$data = {
  readonly id: string;
  readonly userCanDeleteTask: boolean | null;
  readonly userCantDeleteTaskReason: CANT_DELETE_TASK_REASON | null;
  readonly fullAccessToProject: boolean | null;
  readonly approved: boolean | null;
  readonly name: string | null;
  readonly readOnly: {
    readonly isReadOnly: boolean | null;
  } | null;
  readonly coverFile: {
    readonly id: string;
  } | null;
  readonly parentTaskId: string | null;
  readonly hasNovaConversation: boolean;
  readonly novaRunningRunId: string | null;
  readonly novaThread: ReadonlyArray<{
    readonly id: string;
    readonly runId: string | null;
    readonly threadId: string | null;
    readonly agentId: string | null;
    readonly versionNumber: number | null;
    readonly status: string | null;
    readonly outcome: string | null;
    readonly answer: string | null;
    readonly userMessageText: string | null;
    readonly actingPerson: {
      readonly fullName: string | null;
      readonly profilePictureId: string | null;
    } | null;
    readonly ranAt: string | null;
    readonly failureState: string | null;
    readonly grounding: {
      readonly resolved: ReadonlyArray<{
        readonly token: string | null;
        readonly scope: string | null;
      }> | null;
      readonly skipped: ReadonlyArray<{
        readonly token: string | null;
      }> | null;
    } | null;
  }>;
  readonly parentTask: {
    readonly id: string;
    readonly companyTaskId: number | null;
    readonly name: string | null;
    readonly parentTask: {
      readonly id: string;
      readonly companyTaskId: number | null;
      readonly name: string | null;
    } | null;
  } | null;
  readonly hasChildren: boolean | null;
  readonly companyTaskId: number | null;
  readonly blocked: boolean | null;
  readonly bug: boolean | null;
  readonly billable: boolean | null;
  readonly highPriority: boolean | null;
  readonly startYear: number | null;
  readonly startMonth: number | null;
  readonly startDay: number | null;
  readonly description: string | null;
  readonly jiraId: string | null;
  readonly jiraKey: string | null;
  readonly vstsId: string | null;
  readonly pipedriveId: string | null;
  readonly isUnit4Task: boolean | null;
  readonly estimateForecast: number | null;
  readonly timeLeft: number | null;
  readonly deadlineDay: number | null;
  readonly deadlineMonth: number | null;
  readonly deadlineYear: number | null;
  readonly startFrom: string | null;
  readonly deadlineFrom: string | null;
  readonly hasLockedTime: boolean | null;
  readonly hasInvoicedTime: boolean | null;
  readonly favoured: boolean | null;
  readonly sageIntacctId: string | null;
  readonly progressDetails: {
    readonly progress: number | null;
  } | null;
  readonly followers: ReadonlyArray<{
    readonly id: string;
    readonly firstName: string | null;
    readonly lastName: string | null;
    readonly profilePictureId: string | null;
    readonly profilePictureDefaultId: number | null;
  } | null> | null;
  readonly taskLabels: ReadonlyArray<{
    readonly label: {
      readonly id: string;
      readonly name: string | null;
      readonly color: string | null;
    } | null;
  } | null> | null;
  readonly subTasks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly estimate: number | null;
        readonly done: boolean | null;
        readonly sortOrder: number | null;
        readonly name: string | null;
        readonly description: string | null;
        readonly startDay: number | null;
        readonly startMonth: number | null;
        readonly startYear: number | null;
        readonly endDay: number | null;
        readonly endMonth: number | null;
        readonly endYear: number | null;
        readonly startFrom: string | null;
        readonly endFrom: string | null;
        readonly role: {
          readonly id: string;
          readonly name: string | null;
        } | null;
        readonly person: {
          readonly id: string;
          readonly firstName: string | null;
          readonly lastName: string | null;
          readonly active: boolean | null;
          readonly profilePictureId: string | null;
          readonly profilePictureDefaultId: number | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly thisTaskDependsOn: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly type: DEPENDENCY_TYPE | null;
        readonly completed: boolean | null;
        readonly taskDependsOnThis: {
          readonly id: string;
          readonly name: string | null;
          readonly companyTaskId: number | null;
          readonly startYear: number | null;
          readonly startMonth: number | null;
          readonly startDay: number | null;
          readonly deadlineDay: number | null;
          readonly deadlineMonth: number | null;
          readonly deadlineYear: number | null;
          readonly statusColumnV2: {
            readonly id: string;
            readonly category: STATUS_CATEGORY | null;
          } | null;
        } | null;
        readonly thisDependsOnTask: {
          readonly id: string;
          readonly name: string | null;
          readonly companyTaskId: number | null;
          readonly startYear: number | null;
          readonly startMonth: number | null;
          readonly startDay: number | null;
          readonly deadlineDay: number | null;
          readonly deadlineMonth: number | null;
          readonly deadlineYear: number | null;
          readonly statusColumnV2: {
            readonly id: string;
            readonly category: STATUS_CATEGORY | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly dependsOnThisTask: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly type: DEPENDENCY_TYPE | null;
        readonly completed: boolean | null;
        readonly taskDependsOnThis: {
          readonly id: string;
          readonly name: string | null;
          readonly companyTaskId: number | null;
          readonly startYear: number | null;
          readonly startMonth: number | null;
          readonly startDay: number | null;
          readonly deadlineDay: number | null;
          readonly deadlineMonth: number | null;
          readonly deadlineYear: number | null;
          readonly statusColumnV2: {
            readonly id: string;
            readonly category: STATUS_CATEGORY | null;
          } | null;
        } | null;
        readonly thisDependsOnTask: {
          readonly id: string;
          readonly name: string | null;
          readonly companyTaskId: number | null;
          readonly startYear: number | null;
          readonly startMonth: number | null;
          readonly startDay: number | null;
          readonly deadlineDay: number | null;
          readonly deadlineMonth: number | null;
          readonly deadlineYear: number | null;
          readonly statusColumnV2: {
            readonly id: string;
            readonly category: STATUS_CATEGORY | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly taskSetSequence: number | null;
  readonly taskSet: {
    readonly id: string;
    readonly name: string | null;
    readonly instanceCount: number | null;
  } | null;
  readonly repeatingTask: {
    readonly id: string;
    readonly repeatType: string | null;
    readonly monday: boolean | null;
    readonly tuesday: boolean | null;
    readonly wednesday: boolean | null;
    readonly thursday: boolean | null;
    readonly friday: boolean | null;
    readonly saturday: boolean | null;
    readonly sunday: boolean | null;
    readonly monthlyDay: number | null;
  } | null;
  readonly statusColumnV2: {
    readonly id: string;
    readonly name: string | null;
    readonly category: STATUS_CATEGORY | null;
    readonly projectGroupStatusColumnId: number | null;
  } | null;
  readonly phase: {
    readonly id: string;
    readonly name: string | null;
    readonly startYear: number | null;
    readonly startMonth: number | null;
    readonly startDay: number | null;
    readonly deadlineDay: number | null;
    readonly deadlineMonth: number | null;
    readonly deadlineYear: number | null;
  } | null;
  readonly sprint: {
    readonly id: string;
    readonly name: string | null;
    readonly startYear: number | null;
    readonly startMonth: number | null;
    readonly startDay: number | null;
    readonly endDay: number | null;
    readonly endMonth: number | null;
    readonly endYear: number | null;
  } | null;
  readonly assignedPersons: ReadonlyArray<{
    readonly id: string;
    readonly firstName: string | null;
    readonly lastName: string | null;
    readonly role: {
      readonly id: string;
      readonly name: string | null;
    } | null;
    readonly profilePictureId: string | null;
    readonly profilePictureDefaultId: number | null;
    readonly email: string | null;
  } | null> | null;
  readonly timeRegistrations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly invoiced: boolean | null;
        readonly xeroInvoiceId: string | null;
        readonly minutesRegistered: number | null;
        readonly lockedInPeriod: boolean | null;
      } | null;
    } | null> | null;
  } | null;
  readonly role: {
    readonly id: string;
    readonly name: string | null;
  } | null;
  readonly googleDriveFiles: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string | null;
        readonly name: string | null;
        readonly link: string | null;
        readonly thumb: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly files: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly mimeType: string | null;
        readonly key: string | null;
        readonly size: number | null;
        readonly yearCreated: number | null;
        readonly monthCreated: number | null;
        readonly dayCreated: number | null;
        readonly hourCreated: number | null;
        readonly minuteCreated: number | null;
        readonly secondCreated: number | null;
        readonly person: {
          readonly id: string;
          readonly fullName: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly referencedFiles: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly mimeType: string | null;
        readonly key: string | null;
        readonly size: number | null;
        readonly yearCreated: number | null;
        readonly monthCreated: number | null;
        readonly dayCreated: number | null;
        readonly hourCreated: number | null;
        readonly minuteCreated: number | null;
        readonly secondCreated: number | null;
        readonly person: {
          readonly id: string;
          readonly fullName: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly commentCount: number | null;
  readonly comments: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly comment: string | null;
        readonly year: number | null;
        readonly month: number | null;
        readonly day: number | null;
        readonly hours: number | null;
        readonly minutes: number | null;
        readonly seconds: number | null;
        readonly person: {
          readonly id: string;
          readonly firstName: string | null;
          readonly lastName: string | null;
          readonly fullName: string | null;
          readonly profilePictureId: string | null;
          readonly profilePictureDefaultId: number | null;
        } | null;
        readonly authorClientContact: {
          readonly id: string;
          readonly firstName: string | null;
          readonly lastName: string | null;
        } | null;
        readonly reactions?: ReadonlyArray<{
          readonly emoji: string;
          readonly count: number;
          readonly viewerHasReacted: boolean;
          readonly persons: ReadonlyArray<{
            readonly id: string;
            readonly fullName: string | null;
          }>;
        }>;
      } | null;
    } | null> | null;
  } | null;
  readonly createdAt: string | null;
  readonly createdBy: {
    readonly id: string;
    readonly firstName: string | null;
    readonly lastName: string | null;
  } | null;
  readonly latestUiUpdateAt: string | null;
  readonly latestUiUpdateBy: {
    readonly id: string;
    readonly firstName: string | null;
    readonly lastName: string | null;
  } | null;
  readonly owner: {
    readonly id: string;
    readonly firstName: string | null;
    readonly lastName: string | null;
    readonly fullName: string | null;
    readonly profilePictureId: string | null;
    readonly profilePictureDefaultId: number | null;
    readonly role: {
      readonly id: string;
      readonly name: string | null;
    } | null;
  } | null;
  readonly project: {
    readonly id: string;
    readonly name: string | null;
    readonly useTaskOwner: boolean | null;
    readonly useTaskFollowers: boolean | null;
    readonly useTaskHierarchy: boolean | null;
    readonly projectStartYear: number | null;
    readonly projectStartMonth: number | null;
    readonly projectStartDay: number | null;
    readonly projectEndYear: number | null;
    readonly projectEndMonth: number | null;
    readonly projectEndDay: number | null;
    readonly stage: {
      readonly id: string;
      readonly name: string | null;
      readonly profile: PROJECT_STATUS | null;
    } | null;
    readonly projectColor: string | null;
    readonly isJiraProject: boolean | null;
    readonly jiraSubtaskType: string | null;
    readonly jiraCloudProject: {
      readonly id: string;
    } | null;
    readonly jiraCloudEpicIds: ReadonlyArray<string | null> | null;
    readonly jiraServerProject: {
      readonly id: string;
    } | null;
    readonly projectGroupId: string | null;
    readonly billable: boolean | null;
    readonly taskLevels: number | null;
    readonly companyProjectId: number | null;
    readonly customProjectId: string | null;
    readonly isProgramRevenueLocked: boolean | null;
    readonly programBudgetType: PROGRAM_BUDGET_TYPE | null;
    readonly program: {
      readonly name: string | null;
      readonly prefix: string | null;
      readonly budgetType: PROGRAM_BUDGET_TYPE | null;
      readonly members: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly role: string | null;
            readonly person: {
              readonly id: string;
            } | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    readonly harvestProject: {
      readonly id: string;
    } | null;
    readonly manualProgressOnProjectEnabled: boolean | null;
    readonly manualProgressOnPhasesEnabled: boolean | null;
    readonly manualProgressOnTasksEnabled: boolean | null;
    readonly vstsProject: string | null;
    readonly vstsAccount: string | null;
    readonly vstsTwoWaySync: boolean | null;
    readonly sprintTimeBox: boolean | null;
    readonly estimationUnit: string | null;
    readonly remainingAutoCalculated: boolean | null;
    readonly rateCard: {
      readonly id: string;
      readonly disabledRoles: ReadonlyArray<{
        readonly id: string;
      } | null> | null;
    } | null;
    readonly projectPersons: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly person: {
            readonly id: string;
            readonly firstName: string | null;
            readonly lastName: string | null;
            readonly fullName: string | null;
            readonly profilePictureId: string | null;
            readonly profilePictureDefaultId: number | null;
            readonly active: boolean | null;
            readonly permissions: ReadonlyArray<string | null> | null;
            readonly harvestUser: boolean | null;
          } | null;
          readonly project: {
            readonly id: string;
          } | null;
          readonly role: {
            readonly id: string;
            readonly name: string | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly client: {
      readonly id: string;
      readonly name: string;
      readonly logoId: string | null;
      readonly logoDefaultId: number | null;
    } | null;
    readonly phases: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly startYear: number | null;
          readonly startMonth: number | null;
          readonly startDay: number | null;
          readonly deadlineYear: number | null;
          readonly deadlineMonth: number | null;
          readonly deadlineDay: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly statusColumnsV2: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly category: STATUS_CATEGORY | null;
          readonly order: number | null;
          readonly jiraStatusId: string | null;
          readonly adoState: string | null;
          readonly projectGroupStatusColumnId: number | null;
          readonly userActions: {
            readonly canDelete: boolean | null;
            readonly canDeleteWithTasks: boolean | null;
            readonly canCreateTask: boolean | null;
            readonly canRename: boolean | null;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly sprints: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly startYear: number | null;
          readonly startMonth: number | null;
          readonly startDay: number | null;
          readonly endYear: number | null;
          readonly endMonth: number | null;
          readonly endDay: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"DeprecatedProjectIndicatorJS_project">;
  } | null;
  readonly " $fragmentType": "taskModalV3_task";
};
export type taskModalV3_task$key = {
  readonly " $data"?: taskModalV3_task$data;
  readonly " $fragmentSpreads": FragmentRefs<"taskModalV3_task">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTaskId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startYear",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startMonth",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDay",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineDay",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineMonth",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineYear",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startFrom",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDay",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endMonth",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endYear",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v28 = [
  (v0/*: any*/),
  (v1/*: any*/),
  (v6/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "StatusColumnV2",
    "kind": "LinkedField",
    "name": "statusColumnV2",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      (v27/*: any*/)
    ],
    "storageKey": null
  }
],
v29 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DependencyTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DependencyType",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "completed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "taskDependsOnThis",
            "plural": false,
            "selections": (v28/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "thisDependsOnTask",
            "plural": false,
            "selections": (v28/*: any*/),
            "storageKey": null
          },
          (v24/*: any*/)
        ],
        "storageKey": null
      },
      (v25/*: any*/)
    ],
    "storageKey": null
  },
  (v26/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectGroupStatusColumnId",
  "storageKey": null
},
v31 = [
  (v0/*: any*/),
  (v3/*: any*/)
],
v32 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "FileTypeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mimeType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "size",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "yearCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "monthCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dayCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hourCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "minuteCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondCreated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": (v31/*: any*/),
            "storageKey": null
          },
          (v24/*: any*/)
        ],
        "storageKey": null
      },
      (v25/*: any*/)
    ],
    "storageKey": null
  },
  (v26/*: any*/)
],
v33 = [
  (v0/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/)
],
v34 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "withCommentReactions"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "subTasks"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "thisTaskDependsOn"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "dependsOnThisTask"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "timeRegistrations"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "googleDriveFiles"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "files"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "referencedFiles"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "comments"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "project",
          "projectPersons"
        ]
      }
    ]
  },
  "name": "taskModalV3_task",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userCanDeleteTask",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userCantDeleteTaskReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullAccessToProject",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "approved",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskReadOnly",
      "kind": "LinkedField",
      "name": "readOnly",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isReadOnly",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "coverFile",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentTaskId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNovaConversation",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "novaRunningRunId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NovaAgentRun",
      "kind": "LinkedField",
      "name": "novaThread",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "runId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "threadId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "agentId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "versionNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "outcome",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "answer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userMessageText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NovaRunAuthor",
          "kind": "LinkedField",
          "name": "actingPerson",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v4/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ranAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "failureState",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NovaGroundingAccount",
          "kind": "LinkedField",
          "name": "grounding",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NovaGroundingResolvedEntry",
              "kind": "LinkedField",
              "name": "resolved",
              "plural": true,
              "selections": [
                (v5/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "scope",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "NovaGroundingReferenceEntry",
              "kind": "LinkedField",
              "name": "skipped",
              "plural": true,
              "selections": [
                (v5/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "parentTask",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v6/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "kind": "LinkedField",
          "name": "parentTask",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v6/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasChildren",
      "storageKey": null
    },
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bug",
      "storageKey": null
    },
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "highPriority",
      "storageKey": null
    },
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jiraId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jiraKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vstsId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pipedriveId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUnit4Task",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "estimateForecast",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeLeft",
      "storageKey": null
    },
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deadlineFrom",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasLockedTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasInvoicedTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "favoured",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sageIntacctId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskProgress",
      "kind": "LinkedField",
      "name": "progressDetails",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "progress",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "followers",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        (v4/*: any*/),
        (v18/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskLabel",
      "kind": "LinkedField",
      "name": "taskLabels",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Label",
          "kind": "LinkedField",
          "name": "label",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "color",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "subTasks",
      "args": null,
      "concreteType": "SubTaskTypeConnection",
      "kind": "LinkedField",
      "name": "__Task_subTasks_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SubTaskTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SubTask",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "estimate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "done",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sortOrder",
                  "storageKey": null
                },
                (v1/*: any*/),
                (v11/*: any*/),
                (v10/*: any*/),
                (v9/*: any*/),
                (v8/*: any*/),
                (v19/*: any*/),
                (v20/*: any*/),
                (v21/*: any*/),
                (v15/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endFrom",
                  "storageKey": null
                },
                (v22/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "person",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v16/*: any*/),
                    (v17/*: any*/),
                    (v23/*: any*/),
                    (v4/*: any*/),
                    (v18/*: any*/)
                  ],
                  "storageKey": null
                },
                (v24/*: any*/)
              ],
              "storageKey": null
            },
            (v25/*: any*/)
          ],
          "storageKey": null
        },
        (v26/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "thisTaskDependsOn",
      "args": null,
      "concreteType": "DependencyTypeConnection",
      "kind": "LinkedField",
      "name": "__Task_thisTaskDependsOn_connection",
      "plural": false,
      "selections": (v29/*: any*/),
      "storageKey": null
    },
    {
      "alias": "dependsOnThisTask",
      "args": null,
      "concreteType": "DependencyTypeConnection",
      "kind": "LinkedField",
      "name": "__Task_dependsOnThisTask_connection",
      "plural": false,
      "selections": (v29/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "taskSetSequence",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskSet",
      "kind": "LinkedField",
      "name": "taskSet",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "instanceCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RepeatingTask",
      "kind": "LinkedField",
      "name": "repeatingTask",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "repeatType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "monday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tuesday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "wednesday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "thursday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "friday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "saturday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sunday",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "monthlyDay",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StatusColumnV2",
      "kind": "LinkedField",
      "name": "statusColumnV2",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v27/*: any*/),
        (v30/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PhaseType",
      "kind": "LinkedField",
      "name": "phase",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Sprint",
      "kind": "LinkedField",
      "name": "sprint",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        (v19/*: any*/),
        (v20/*: any*/),
        (v21/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "assignedPersons",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        (v22/*: any*/),
        (v4/*: any*/),
        (v18/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "timeRegistrations",
      "args": null,
      "concreteType": "TimeRegTypeConnection",
      "kind": "LinkedField",
      "name": "__Task_timeRegistrations_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeRegTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeRegType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "invoiced",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "xeroInvoiceId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minutesRegistered",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lockedInPeriod",
                  "storageKey": null
                },
                (v24/*: any*/)
              ],
              "storageKey": null
            },
            (v25/*: any*/)
          ],
          "storageKey": null
        },
        (v26/*: any*/)
      ],
      "storageKey": null
    },
    (v22/*: any*/),
    {
      "alias": "googleDriveFiles",
      "args": null,
      "concreteType": "GoogleDriveFileTypeConnection",
      "kind": "LinkedField",
      "name": "__Task_googleDriveFiles_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GoogleDriveFileTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GoogleDriveFile",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "link",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "thumb",
                  "storageKey": null
                },
                (v24/*: any*/)
              ],
              "storageKey": null
            },
            (v25/*: any*/)
          ],
          "storageKey": null
        },
        (v26/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "files",
      "args": null,
      "concreteType": "FileTypeConnection",
      "kind": "LinkedField",
      "name": "__Task_files_connection",
      "plural": false,
      "selections": (v32/*: any*/),
      "storageKey": null
    },
    {
      "alias": "referencedFiles",
      "args": null,
      "concreteType": "FileTypeConnection",
      "kind": "LinkedField",
      "name": "__Task_referencedFiles_connection",
      "plural": false,
      "selections": (v32/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "commentCount",
      "storageKey": null
    },
    {
      "alias": "comments",
      "args": null,
      "concreteType": "CommentTypeConnection",
      "kind": "LinkedField",
      "name": "__Task_comments_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CommentTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CommentType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "comment",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "year",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "month",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "day",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hours",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minutes",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "seconds",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "person",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v16/*: any*/),
                    (v17/*: any*/),
                    (v3/*: any*/),
                    (v4/*: any*/),
                    (v18/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ClientContact",
                  "kind": "LinkedField",
                  "name": "authorClientContact",
                  "plural": false,
                  "selections": (v33/*: any*/),
                  "storageKey": null
                },
                {
                  "condition": "withCommentReactions",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CommentReactionType",
                      "kind": "LinkedField",
                      "name": "reactions",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "emoji",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "count",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "viewerHasReacted",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Person",
                          "kind": "LinkedField",
                          "name": "persons",
                          "plural": true,
                          "selections": (v31/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ]
                },
                (v24/*: any*/)
              ],
              "storageKey": null
            },
            (v25/*: any*/)
          ],
          "storageKey": null
        },
        (v26/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "createdBy",
      "plural": false,
      "selections": (v33/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "latestUiUpdateAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "latestUiUpdateBy",
      "plural": false,
      "selections": (v33/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v18/*: any*/),
        (v22/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTaskOwner",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTaskFollowers",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTaskHierarchy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectStartYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectStartMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectStartDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectEndYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectEndMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectEndDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "stage",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profile",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isJiraProject",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jiraSubtaskType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "JiraCloudProjectType",
          "kind": "LinkedField",
          "name": "jiraCloudProject",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "jiraCloudEpicIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "JiraServerProjectType",
          "kind": "LinkedField",
          "name": "jiraServerProject",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectGroupId",
          "storageKey": null
        },
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taskLevels",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyProjectId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customProjectId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DeprecatedProjectIndicatorJS_project"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isProgramRevenueLocked",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "programBudgetType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProgramType",
          "kind": "LinkedField",
          "name": "program",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "prefix",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "budgetType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectServiceProgramMemberTypeConnection",
              "kind": "LinkedField",
              "name": "members",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectServiceProgramMemberTypeEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProjectServiceProgramMemberType",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "role",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Person",
                          "kind": "LinkedField",
                          "name": "person",
                          "plural": false,
                          "selections": (v2/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "HarvestProjectType",
          "kind": "LinkedField",
          "name": "harvestProject",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "manualProgressOnProjectEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "manualProgressOnPhasesEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "manualProgressOnTasksEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vstsProject",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vstsAccount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vstsTwoWaySync",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sprintTimeBox",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "estimationUnit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "remainingAutoCalculated",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RateCard",
          "kind": "LinkedField",
          "name": "rateCard",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Role",
              "kind": "LinkedField",
              "name": "disabledRoles",
              "plural": true,
              "selections": (v2/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "projectPersons",
          "args": null,
          "concreteType": "ProjectPersonTypeConnection",
          "kind": "LinkedField",
          "name": "__Project_projectPersons_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectPersonTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectPerson",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Person",
                      "kind": "LinkedField",
                      "name": "person",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v16/*: any*/),
                        (v17/*: any*/),
                        (v3/*: any*/),
                        (v4/*: any*/),
                        (v18/*: any*/),
                        (v23/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "permissions",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "harvestUser",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProjectType",
                      "kind": "LinkedField",
                      "name": "project",
                      "plural": false,
                      "selections": (v2/*: any*/),
                      "storageKey": null
                    },
                    (v22/*: any*/),
                    (v24/*: any*/)
                  ],
                  "storageKey": null
                },
                (v25/*: any*/)
              ],
              "storageKey": null
            },
            (v26/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Client",
          "kind": "LinkedField",
          "name": "client",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "logoId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "logoDefaultId",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v34/*: any*/),
          "concreteType": "PhaseTypeConnection",
          "kind": "LinkedField",
          "name": "phases",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PhaseTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PhaseType",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    (v8/*: any*/),
                    (v9/*: any*/),
                    (v10/*: any*/),
                    (v14/*: any*/),
                    (v13/*: any*/),
                    (v12/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "phases(first:10000)"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1000000
            }
          ],
          "concreteType": "StatusColumnV2TypeConnection",
          "kind": "LinkedField",
          "name": "statusColumnsV2",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "StatusColumnV2TypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StatusColumnV2",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    (v27/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "order",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jiraStatusId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "adoState",
                      "storageKey": null
                    },
                    (v30/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "StatusColumnUserActions",
                      "kind": "LinkedField",
                      "name": "userActions",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "canDelete",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "canDeleteWithTasks",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "canCreateTask",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "canRename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "statusColumnsV2(first:1000000)"
        },
        {
          "alias": null,
          "args": (v34/*: any*/),
          "concreteType": "SprintTypeConnection",
          "kind": "LinkedField",
          "name": "sprints",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SprintTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Sprint",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    (v8/*: any*/),
                    (v9/*: any*/),
                    (v10/*: any*/),
                    (v21/*: any*/),
                    (v20/*: any*/),
                    (v19/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "sprints(first:10000)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Task",
  "abstractKey": null
};
})();

(node as any).hash = "e8e0c677a4c43544780bb9f7c3644949";

export default node;
